import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Select from "react-select";
import { AiOutlineClose } from "react-icons/ai";
import { BsWindowStack } from "react-icons/bs";
import { FaSave } from "react-icons/fa";
import { SiBookstack } from "react-icons/si";
import { GrDocument } from "react-icons/gr";
import { GiCrossMark } from "react-icons/gi";
import { AiFillPrinter } from "react-icons/ai";
import { TbWindowMaximize, TbWindowMinimize } from "react-icons/tb";
import AllPageNavbar from "../Components/AllPageNavbar";
import DashBoardNavbar from "../Components/DashBoardNavbar";
import HomePageNavbarFinancials from "../Components/HomePageNavbarFinancials";
import Loading from "../Components/Loading";
import { useDispatch, useSelector } from "react-redux";
const AreaCreation = () => {
  const BASEURL = process.env.REACT_APP_BASEURL;
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const userState = useSelector((state) => state.changeTheState.user);
  const LoggedInUserName = userState?.emailId?.split("@")[0].toUpperCase();
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(true);

  const [areadId, setAreaId] = useState("")
  const [areaName, setAreaName] = useState("")
  const [areaList, setAreaList] = useState([])
  const [searchArea,setSearchArea] = useState("") 



    const filteredData = areaList?.filter((item) => {
    const searchData = searchArea?.toLowerCase()?.split(" ")?.filter(Boolean);
    const textMatch =
      searchData?.length === 0 ||
      searchData.every((term) => {
        return [
          "OM_AREA_NAME",
          "OM_AREA_ID",
        ].some((key) => {
          const columnValue = String(item[key])?.toLowerCase();
          return columnValue?.includes(term);
        });
      });
    return textMatch;
  });

  useEffect(() => {
    masterData();
  }, []);

  function masterData() {
    setisloading(true);
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1675`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setAreaId(response?.data?.[0]?.AREAID);
      }).catch((error) => {
        console.error("Error fetching data 1675:", error);
        setisloading(false);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=299`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setAreaList(response?.data);
        setisloading(false);
      })
      .catch((error) => {
        console.error("Error fetching data 299:", error);
        setisloading(false);
      });
  }

    async function submitCategory(type) {
    if (!areaName) {
      alert("Kindly Supply Area name");
      return;
    }
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1678&successstatus=true`,
        {
          AREAID: Number(areadId),
          AREAMNAME: areaName,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        }
      );

      if (response.status === 201) {
        alert(`Area Created successfully`);
        window.location.reload();
      } else {
        alert(response?.data?.message);
        console.error(`Error while Creating Area`);
      }
    } catch (error) {
      console.log(error);
      alert(error?.response?.data?.message);
      console.error(`Error while Creating Area`, error);
    }
  }
  if (isloading) {
    return <Loading />;
  }
  return (
    <div>
      {" "}
      <>
          <DashBoardNavbar />
              <HomePageNavbarFinancials/>
        <header className="header__of__main lg:flex  justify-between items-end px-3 ">
          <h1 className="header__of__page"> AREA MASTER</h1>
          <div className="my-1">
            <button
              className=" bg-[#002d62]  text-white rounded-md px-2 h-[30px]  lg:ml-2 mr-2 "
              onClick={() => submitCategory("new")}
            >
              Save
            </button>
            <button
              className=" bg-[#002d62]  text-white rounded-md px-2 h-[30px]  lg:ml-2 mr-2 "
              onClick={() => submitCategory("update")}
            >
              Update
            </button>
            <button
              className=" bg-[#002d62]  text-white rounded-md px-2 h-[30px]  lg:ml-2 mr-2 "
              onClick={() => {
                window.location.reload();
              }}
            >
              Reset
            </button>
          </div>
        </header>
        <div>
          <article>
            <section className=" shadow-slate-100	m-2 bg-gray-100 border-black rounded	p-2 ">
              <aside className="lg:flex lg:my-1 lg:mb-3">
                <p className="lg:ml-2">Area Id :</p>
                <input
                  className="lg:ml-2 w-20 text-right"
                  value={areadId}
                    readOnly
                ></input>
                <p className="lg:ml-2">Area Name :</p>
                <input
                  className="lg:ml-2 w-96"
                  type="text"
                  value={areaName}
                  onChange={(e) => {
                    setAreaName(e.target.value);
                  }}
                ></input>
              </aside>
            </section>
          </article>
        </div>
        <section className="table__pos__app w-[98%]  ">
          <div className="lg:flex items-center">
            <p className="lg:mx-2 text-[16px]">Search</p>
            <input
              className="w-[200px] lg:mr-[50px]"
              required
              value={searchArea}
              onChange={(e) => {
                setSearchArea(e.target.value);
              }}
            ></input>
          </div>

          <table class="custom-table ">
            <thead class="header-cell">
              <tr>
                <td>S No</td>
                <td>AREA ID</td>
                <td>AREA NAME</td>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(filteredData) && filteredData.length > 0 ? (
                filteredData.map((value, index) => (
                  <tr
                    key={value?.OM_AREA_ID}
                    className="table-row"
                    onClick={() => {
                      setAreaId(value?.OM_AREA_ID);
                      setAreaName(value?.OM_AREA_NAME)
                    }}
                  >
                    <td className="text-right">{index + 1}</td>
                    <td className="text-right">{value.OM_AREA_ID ? value.OM_AREA_ID : "N/A"}</td>
                    <td>{value.OM_AREA_NAME ? value.OM_AREA_NAME : "N/A"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </section>
      </>
    </div>
  );
};

export default AreaCreation;
